export const PXTestimonialSlider = (function () {
	'use strict';

	function init() {
		events();
	}

	function events() {
		$('#testimonial-slider').slick({
			dots: false,
			arrows: true,
			speed: 600,
			autoplay: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: true,
					},
				},
			],
		});
	}

	return {
		init: init,
	};
})();
